import {StandardDialogFooter} from "../../../../../pages/components/dialogs/standard-dialog/standard-dialog";
import React, {useState} from "react";
import {Grid} from "@mui/material";
import Message from "../../../../../pages/components/message";
import {MessageSections} from "../../../../../pages/components/message/message";
import {useAppSelector} from "../../../../../redux/store";
import BarekamInput from "../../../../../pages/components/input";
import {LocationModel} from "../../../../../pages/shared/models/location.model";
import {ActionDialogContent} from "./styled";
import {getMessage} from "../../../../../pages/shared/helper-functions";

const LocationSelect = ({onSave, onCancel}: LocationSelectDialogProps) => {
    const [location, setLocation] = useState<LocationModel>({
        depot: '',
        sector: null,
        corridor: null,
        rack: null,
        bin: null,
    } as LocationModel);
    const [errors, setErrors] = useState<{[key: string]: string}>({});


    function onChange(place: 'depot' | 'sector' | 'corridor' | 'rack' | 'bin', value: string) {
        setLocation(prevState => {
            prevState[place] = value;
            return {...prevState};
        })
    }

    function handleSave() {
        if (passedValidations()) {
            onSave(location);
        }
    }

    function passedValidations() {
        if (!location.depot) {
            setErrors({depot: 'required'});
            return false;
        } else {
            return true
        }
    }

    return (
        <>
            <ActionDialogContent>
                <Grid container rowSpacing={'1rem'} columnSpacing={'1rem'}>
                    <LocationInput place={"depot"} location={location} onChange={onChange} errors={errors}/>
                    <LocationInput place={"sector"} location={location} onChange={onChange} errors={errors}/>
                    <LocationInput place={"corridor"} location={location} onChange={onChange} errors={errors}/>
                    <LocationInput place={"rack"} location={location} onChange={onChange} errors={errors}/>
                    <LocationInput place={"bin"} location={location} onChange={onChange} errors={errors}/>
                </Grid>
            </ActionDialogContent>

            <StandardDialogFooter saveLabel={<Message messageKey={'save'} sectionId={MessageSections.ORDERS}/>}
                                  onSave={() => handleSave()}
                                  onCancel={() => onCancel()}/>
        </>
    );
}

const LocationInput = ({place, location, onChange, errors}: {place: 'depot' | 'sector' | 'corridor' | 'rack' | 'bin', location: LocationModel, onChange: any, errors: {[key: string]: string}}) => {
    const {messageCache, languageId} = useAppSelector(state => state.messagesReducer);

    return (
        <Grid item xs={6}>
            <BarekamInput key={place}
                          customInputVariant={"standard"}
                          placeholder={getMessage(place, MessageSections.ORDERS, messageCache, languageId)}
                          value={location[place] || ''}
                          onChange={(event) => onChange(place, event.target.value)}
                          error={!!errors[place]}
                          errorMessage={errors[place] && getMessage(errors[place], MessageSections.ORDERS, messageCache, languageId)}
                          width={'100%'}
                          required={place === 'depot'}/>
        </Grid>
    )
}

interface LocationSelectDialogProps {
    onSave: (location: LocationModel) => void,
    onCancel: () => void,
}

export default LocationSelect;